<script>
import { required, integer, minValue, maxValue } from "vuelidate/lib/validators";

export default {
  name: "pkf-form",
  props: {
    value: { type: Object, default: () => {} },
  },

  data: (vm) => ({
    form: {
      specs: {
        size: null,
        color: null,
        table_system: null,
        tube_length: 80,
      },
      ...vm.value,
    },
  }),
  computed: {
    colors() {
      if (this.form.specs.size === "xlarge") {
        return [
          { value: null, text: "- Select a Color -" },
          { value: "black", text: this.$t("attribute.color.black") },
        ];
      }

      return [
        { value: null, text: "- Select a Color -" },
        { value: "titan", text: this.$t("attribute.color.titan") },
      ];
    },
    sizes() {
      return [
        { value: null, text: "- Select a Size -" },
        { value: "small", text: this.$t("attribute.size.small") },
        { value: "medium", text: this.$t("attribute.size.medium") },
        { value: "large", text: this.$t("attribute.size.large") },
        { value: "xlarge", text: this.$t("attribute.size.xlarge") },
      ];
    },
    tableSystemOptions() {
      return [
        { value: null, text: "- Select a Table System -" },
        { value: "front", text: this.$t("attribute.table_system.front") },
        { value: "back", text: this.$t("attribute.table_system.back") },
        { value: "no", text: this.$t("attribute.table_system.no") },
      ];
    },
  },
  watch: {
    "form.specs.size": {
      handler(v) {
        if (v === "xlarge") {
          this.form.specs.color = "black";
        }
      },
    },
  },
  validations: {
    form: {
      specs: {
        size: {
          required,
        },
        color: {
          required,
        },
        table_system: {
          required,
        },
        tube_length: {
          required,
          integer,
          minValue: minValue(50),
          maxValue: maxValue(115),
        },
      },
    },
  },
  methods: {
    validate() {
      if (!this.$v && !this.$v.form) return true;
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.$emit("validated", { ...this.form });
        this.$emit("input", { ...this.form });
      }

      return !this.$v.form.$invalid;
    },
  },
};
</script>
<template>
  <b-row>
    <b-col cols="12">
      <g-form-error-wrapper :validations="$v.form.specs.size">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.size"
            :label="$t('Size')"
            maxWidth="200px"
            :options="sizes"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.size.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>
      <g-form-error-wrapper :validations="$v.form.specs.color">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.color"
            :label="$t('Color')"
            maxWidth="200px"
            :options="colors"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.color.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.table_system">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.table_system"
            :label="$t('Table System')"
            :options="tableSystemOptions"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.table_system.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.tube_length">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model.number="form.specs.tube_length"
            :label="$t('Patient Tube Length')"
            append="cm"
            maxWidth="80px"
            text-align="center"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.tube_length.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>

      <label for="comments">{{ $t("comments") }}</label>
      <b-form-textarea
        id="comments"
        :placeholder="$t('extra comments or requirements')"
        v-model="form.comments"
        rows="4"
        max-rows="4"
      />
    </b-col>
  </b-row>
</template>
